import { getDisplayName } from '@/helpers/duelCard';
import type { DuelCardState, DuelPlayer } from './types';

interface DuelCardVoteBarProps {
  p1Pct: number;
  p2Pct: number;
  player1: DuelPlayer;
  player2: DuelPlayer;
  player1Votes?: number;
  player2Votes?: number;
  state: DuelCardState;
  disabledSelect: boolean;
  onHighlightChange: (player: 'player1' | 'player2' | null) => void;
}

function formatLabel(name: string, pct: number, votes?: number): string {
  const base = getDisplayName(name, pct);
  if (votes !== undefined && votes !== null) return `${base} (${votes})`;
  return base;
}

export function DuelCardVoteBar({
  p1Pct,
  p2Pct,
  player1,
  player2,
  player1Votes,
  player2Votes,
  state,
  disabledSelect,
  onHighlightChange,
}: DuelCardVoteBarProps) {
  return (
    <div
      className={`vote-bar mb-3 ${state !== 'active' ? 'vote-bar--disabled' : ''}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseEnter={(e) => {
        if (disabledSelect) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const width = rect.width;
        const leftWidth = (p1Pct / 100) * width;
        onHighlightChange(x < leftWidth ? 'player1' : 'player2');
      }}
      onMouseLeave={() => onHighlightChange(null)}
      onTouchStart={(e) => {
        if (disabledSelect) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const touch = e.touches[0];
        const x = touch.clientX - rect.left;
        const width = rect.width;
        const leftWidth = (p1Pct / 100) * width;
        onHighlightChange(x < leftWidth ? 'player1' : 'player2');
      }}
      onTouchEnd={() => onHighlightChange(null)}
      onTouchCancel={() => onHighlightChange(null)}
    >
      <div className="seg left" style={{ width: `${p1Pct}%` }} />
      <div className="seg right" style={{ width: `${p2Pct}%` }} />
      <span
        className={`label left ${p1Pct < 15 ? 'hide-label' : ''}`}
        style={{ display: p1Pct === 0 ? 'none' : 'block' }}
        title={player1Votes != null ? `${player1.name} ${p1Pct}% (${player1Votes})` : `${player1.name} ${p1Pct}%`}
      >
        {formatLabel(player1.name, p1Pct, player1Votes)}
      </span>
      <span
        className={`label right ${p2Pct < 15 ? 'hide-label' : ''}`}
        style={{ display: p2Pct === 0 ? 'none' : 'block' }}
        title={player2Votes != null ? `${player2.name} ${p2Pct}% (${player2Votes})` : `${player2.name} ${p2Pct}%`}
      >
        {formatLabel(player2.name, p2Pct, player2Votes)}
      </span>
    </div>
  );
}
